module.exports = __webpack_public_path__ + "img/developerMeetup.4097f121.png";